import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {EditProfileRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/EditProfileRequest';
import {User} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Form, FormProps} from '@mintdata-wsp/wsp/ui/components/forms/data/Form';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogButton} from '@mintdata-wsp/wsp/ui/components/forms/DialogButton';
import {DialogError} from '@mintdata-wsp/wsp/ui/components/forms/DialogError';
import {Expander} from '@mintdata-wsp/wsp/ui/components/forms/Expander';
import {Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {EditProfileDialogValidators} from '@mintdata-wsp/wsp/ui/dialogs/profile/EditProfileDialogValidator';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const md5 = require('md5');

const styles = require('./EditProfileDialog.less');
const cx = classnames.bind(styles);

export interface EditProfileDialogProps
{
}

export class EditProfileDialogState
{
    isViewPasswords:boolean = false;
    isViewSave:boolean = false;
    isSaveDisabled:boolean = true;
    isFullNameEditMode:boolean = false;
}

@observer
export class EditProfileDialog extends React.Component<EditProfileDialogProps, EditProfileDialogState>
{
    private _form:Form = new Form({onChange: this._onFormChanged} as FormProps);

    private _validators = new EditProfileDialogValidators({_form: this._form});

    @observable
    private _serverError:string = '';

    constructor(props:any)
    {
        super(props);

        this.state = new EditProfileDialogState();
    }

    @bind
    private _onFormChanged(fieldKey:string, fieldValue:any, isValid:boolean):void
    {
        this._checkUiState();
    }

    @bind
    private _onChangeFullName(newValue:string):void
    {
    }

    @bind
    private _onSetEditModeFullName():void
    {
        this.setState({isFullNameEditMode: true}, this._checkUiState);
    }

    @bind
    private _togglePasswords(isExpanded):void
    {
        this.setState({isViewPasswords: isExpanded}, () =>
        {
            this._checkUiState();

            const fields = ['password', 'newPassword', 'retypePassword'];

            this._form.getFields(fields).forEach(field =>
            {
                field.elementRef.checkIsValid();
            });
        });
    }

    private _closeDialog():void
    {
        controllers.ui.dialogs.hideDialog(Dialogs.EditProfile);
    }

    @bind
    private _checkUiState():void
    {
        const {isViewPasswords, isFullNameEditMode} = this.state;

        let isViewSave = false;

        // TODO
        if( isFullNameEditMode )
            isViewSave = true;

        if( isViewPasswords )
            isViewSave = true;

        let isSaveDisabled = true;

        if( isViewSave )
        {
            let fieldsForCheck;

            if( !isViewPasswords )
                fieldsForCheck = ['fullName'];

            let areSomeFieldChanged = this._form.areSomeFieldChanged(fieldsForCheck);
            let areAllFieldsValid = this._form.areAllFieldsValid(fieldsForCheck);

            // if (!areSomeFieldChanged || areAllFieldsValid){
            if( areAllFieldsValid )
            {
                isSaveDisabled = !areSomeFieldChanged;
            }
        }

        this.setState({isViewSave});
        this.setState({isSaveDisabled});
    }

    @bind
    private _save():void
    {
        const {isViewPasswords, isSaveDisabled} = this.state;

        if( isSaveDisabled )
        {
            return;
        }

        let fieldsForSave:string[];

        if( isViewPasswords )
            fieldsForSave = ['fullName', 'password', 'newPassword', 'retypePassword'];
        else
            fieldsForSave = ['fullName'];

        let areAllFieldsValid = this._form.areAllFieldsValid(fieldsForSave);
        let areSomeFieldChanged = this._form.areSomeFieldChanged(fieldsForSave);

        if( !areAllFieldsValid && !areSomeFieldChanged )
        {
            // strange - btn 'save' must be disabled
            return;
        }

        // const fields = this._form.getFields(fieldsForSave);

        let fullName = this._form.get('fullName');
        let email = '';
        let password = '';
        let newPassword = '';

        if( isViewPasswords )
        {
            password = md5(this._form.get('password'));
            newPassword = md5(this._form.get('newPassword'));
        }

        const {currentUser} = rootState.userSession;
        const isNameChanged = fullName !== currentUser.fullName;

        controllers.user.editProfile(new EditProfileRequest(
            fullName,
            password,
            newPassword,
            email
        ))
            .then((response) =>
            {
                controllers.ui.dialogs.hideDialog(Dialogs.EditProfile);

                if( isNameChanged )
                {
                    controllers.analytics.main.trackEvent(
                        AnalyticsEventActions.WSP_PROFILE_NAME_EDITED,
                        {
                            user_fullname: fullName
                        }
                    );
                }

                if( password && newPassword )
                {
                    controllers.analytics.main.trackEvent(
                        AnalyticsEventActions.WSP_PROFILE_CHANGED_PASSWORD,
                        {
                            user_fullname: fullName
                        }
                    );
                }

            })
            .catch(action((err:ApiError) =>
            {
                if( ApiError.isError(err) )
                {
                    this._serverError = err.message;
                }
            }));
    }

    @bind
    private _handleClose():void
    {
        controllers.ui.dialogs.hideDialog(Dialogs.EditProfile);
    }

    render()
    {
        const user = rootState.userSession.currentUser;

        const {isViewPasswords, isViewSave, isSaveDisabled} = this.state;

        return (
            <Dialog
                onEnterKey={this._save}
                title={'My Profile'}
                onClose={this._handleClose}
            >
                {/*<WSPImage className={cx('logo')} image={WSPImages.MintDataLogoDialog}/>*/}

                {/*<WSPButton style={ButtonStyle.SimpleSecondary}*/}
                {/*className={cx('closeDialog')}*/}
                {/*icon={MDIcons.common.Close}*/}
                {/*size={ButtonSize.Small}*/}
                {/*onClick={this._closeDialog}*/}
                {/*/>*/}

                {!!this._serverError && <DialogError message={this._serverError} />}

                <Row className={cx('content')}>

                    <Column className={cx('avatarContainer')}>
                        {user.avatarUrl
                            ? <img src={user.avatarUrl} className={cx('avatar')} />
                            : User.initials(user)}
                    </Column>

                    <Column className={cx('inputs')}>

                        <Input
                            icon={MDIcons.common.Person}
                            style={InputStyle.Dialog}
                            className={cx('input')}
                            placeholder={'Full Name'}
                            isValidFn={this._validators.fullName}
                            initialValue={user.fullName}
                            isClickForEdit={true}
                            formKey={'fullName'}
                            form={this._form}
                            onChange={this._onChangeFullName}
                            onSetEditMode={this._onSetEditModeFullName}
                        />

                        <Input
                            icon={MDIcons.common.Email}
                            style={InputStyle.Dialog}
                            className={cx('input')}
                            placeholder={'Email'}
                            initialValue={user.email}
                            formKey={'email'}
                            form={this._form}
                            isReadOnly={true}
                        />

                        <Expander
                            text={'Update password'}
                            isInitiallyExpanded={isViewPasswords}
                            className={cx('viewPasswords')}
                            onIsExpandedChanged={this._togglePasswords}
                        >

                            <Column className={cx('inputs', 'passwords')}>

                                <Input
                                    icon={MDIcons.common.PasswordKey}
                                    style={InputStyle.Dialog}
                                    className={cx('input')}
                                    placeholder={'Current Password'}
                                    isPassword={true}
                                    isValidFn={(value) =>
                                    {
                                        return isViewPasswords
                                            ? this._validators.password(value)
                                            : true;
                                    }}
                                    formKey={'password'}
                                    form={this._form}
                                />

                                <Input
                                    icon={MDIcons.common.PasswordKey}
                                    style={InputStyle.Dialog}
                                    className={cx('input')}
                                    placeholder={'New Password'}
                                    isPassword={true}
                                    isValidFn={(value) =>
                                    {
                                        return isViewPasswords
                                            ? this._validators.newPassword(value)
                                            : true;
                                    }}
                                    formKey={'newPassword'}
                                    form={this._form}
                                />

                                <Input
                                    icon={MDIcons.common.PasswordKey}
                                    style={InputStyle.Dialog}
                                    className={cx('input')}
                                    placeholder={'Retype New Password'}
                                    isPassword={true}
                                    isValidFn={(value) =>
                                    {
                                        return isViewPasswords
                                            ? this._validators.retypePassword(value)
                                            : true;
                                    }}
                                    formKey={'retypePassword'}
                                    form={this._form}
                                />

                            </Column>

                        </Expander>

                        <DialogButton
                            caption={'Save'}
                            className={cx('saveButton', {'isHide': !isViewSave, 'isDisabled': isSaveDisabled})}
                            onClick={this._save}
                            isDisabled={isSaveDisabled}
                        />

                    </Column>

                </Row>
            </Dialog>
        );
    }
}
